import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import friend1 from './pictures/friend1.JPG';
import friend2 from './pictures/friend2.JPG';
import friend3 from './pictures/friend3.JPG';
import friend4 from './pictures/friend4.JPG';
import friend5 from './pictures/friend5.JPG';
import friend6 from './pictures/friend6.JPG';
import friend7 from './pictures/friend7.JPG';
import friend8 from './pictures/friend8.JPG';
import friend9 from './pictures/friend9.JPG';

const Friendsgiving = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC Friendsgiving!</h2>
                    <p class="site-post-meta">November 19th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    On Tuesday, November 19th, we hosted our Friendsgiving celebration! 🦃

                    Thank you so much to everyone who came and enjoyed some Thai food and enjoyed some games with us (p.s., the Thai food was from Ti22 if anyone was wondering 👀)

                    Thank you all for coming, we're super grateful for you! 🥰
                    </p>
                    <img src={friend1} alt="pic1 "/>
                    <img src={friend2} alt="pic2 "/>
                    <img src={friend3} alt="pic3 "/>
                    <img src={friend4} alt="pic4 "/>
                    <img src={friend5} alt="pic5 "/>
                    <img src={friend6} alt="pic6 "/>
                    <img src={friend7} alt="pic7 "/>
                    <img src={friend8} alt="pic8 "/>
                    <img src={friend9} alt="pic9 "/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Friendsgiving;
